import { ControlValueAccessor } from '@angular/forms';

/**
 * from https://rangle.io/blog/angular-2-ngmodel-and-custom-form-components/
 */
export class ValueAccessorBase<T> implements ControlValueAccessor {
  protected innerValue: T;

  get value(): T {
    return this.innerValue;
  }

  set value(value: T) {
    if (this.innerValue !== value) {
      this.innerValue = value;
      this.changed(value);
    }
  }
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  public changed: any = () => {};

  public registerOnChange(fn: () => {}): void {
    this.changed = fn;
  }

  public registerOnTouched(fn: () => {}): void {
    this.touched = fn;
  }
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  public touched: any = () => {};

  public writeValue(value: T): void {
    this.innerValue = value;
  }
}
